export default {
    class: [],
    income: [],
    expense: []
}